<template>
    <div class="common-container-fluid">
        <div class="title-item">
            <div class="title">
                培训认证介绍
            </div>
            <div class="des">紫光云培训服务是专注于用云和管云的培训服务，旨在通过该培训后用户能完成日常的资源开通和维护</div>
            <div class="title-btn">
                <el-button class="btn" type="primary" @click="jumpToLogin">查看证书</el-button>
            </div>
            <div class="detail-item">
                <div  class="item-line">
                    <div class="item-part" style="width: 190px;padding: 89px 0px;">
                        <div class="item-des">基于客户部署紫光云平台产品定制个性化的开班课程</div>
                    </div>
                    <div class="item-part" style="width: 320px;padding: 0 259px;">
                        <div class="main-title">培训系统</div>
                        <div class="item-des" style="color: rgba(0,0,0,0.9);padding: 22px 0;text-align: justify;">面向已经采买紫光云软件产品的客户，提供紫光云平台的方案、云网实现方案、云平台产品介绍以及基于客户用云场景的实战操作实践等培训课程。</div>

                    </div>
                    <div class="item-part" style="width: 190px;padding: 101px 0px;">
                        <div class="item-des">资深讲师团队教学，深度讲解紫光云平台技术</div>

                    </div>


                </div>
            </div>


        </div>
        <div class="des-item">
            <div class="title">培训内容</div>
            <el-row class="product-line">
                <el-col class="product-item" v-for="product in productList" :key="product.name">
                    <div> 
                        <img class="product-icon" :src=product.icon alt=""/>
                    </div>
                    <div class="product-name">{{ product.name }}</div>
                    <div class="product-des">{{ product.des }}</div>

                </el-col>
            </el-row>
        </div>
        <div class="method-item">
            <div class="title">培训<span class="colorful">方式</span></div>
            <div class="method-line">
                <div class="method-card bg2">
                    <div class="type">线上培训</div>
                    <div class="des">通过灵活的线上培训，能随时协调专家远程培训，时间更易协调。</div>
                </div>
                <div class="method-card bg1">
                    <div class="type">线下培训</div>
                    <div class="des">通过线下方式与学员进行面对面的交流和互动，及时解决疑问。</div>
                </div>
            </div>
            <div class="title">适合<span class="colorful">人群</span></div>
            <div class="groups-line">
                <div class="groups-card bg1">
                    <div class="type">1、IT 技术人员</div>
                    <div class="des">系统管理员、网络工程师等希望拓展技能，了解云计算领域，以便能够更好地管理和维护企业的IT基础设施。通过云计算培训将传统的本地服务器管理经验与云计算技术相结合，实现企业 IT 系统的云化转型。</div>
                </div>
                <div class="groups-card bg2">
                    <div class="type">2、软件开发人员</div>
                    <div class="des">软件开发人员可以学习如何将应用程序更好地部署到云平台上，利用云原生技术提高开发效率和应用的可扩展性。例如，掌握容器技术后，开发人员可以将应用及其依赖打包成容器，方便在不同的云环境中快速部署。</div>
                </div>
                <div class="groups-card bg3">
                    <div class="type">3、企业管理人员和决策者</div>
                    <div class="des">对于企业的管理人员和决策者，云计算培训可以帮助他们了解云计算的战略价值，从而在企业的数字化转型过程中做出正确的决策。如是否采用公有云、私有云还是混合云，以及如何评估云计算服务提供商等。</div>
                </div>

            </div>

        </div>
        
    </div>
</template>

<script>
import trainingReq from "~/request/trainingReq";
import countDown from "./Components/count-down";


export default {
    components: {
        countDown,
    },
    data() {
        return {
            productList:[
                {
                    name:"云计算产品",
                    icon:require("../../assets/img/traning/icon1.png"),
                    des:"云计算的产品介绍，根据每一个私有云项目定制的云产品介绍，便于用户了解当前云上已上架的产品和功能，以及云平台的能力介绍，便于用户未来对云平台扩展。" 
                },
                {
                    name:"云平台方案",
                    icon:require("../../assets/img/traning/icon2.png"),
                    des:"介绍紫光云Cloudos 7.0的架构设计，包括资源层、服务层、管理层和用户层，介绍云平台的模块化设计，如计算、存储、网络、数据库等核心组件。" 
                },
                {
                    name:"网络架构",
                    icon:require("../../assets/img/traning/icon3.png"),
                    des:"云网实现方案介绍，介绍云平台的网络隔离、安全组、负载均衡等关键功能，介绍云平台的网络架构，包括虚拟网络、SDN（软件定义网络）和OVN架构原理等。" 
                },
                {
                    name:"高可用方案",
                    icon:require("../../assets/img/traning/icon4.png"),
                    des:"云平台高可用方案介绍，介绍高可用性（HA）的设计原则，包括故障检测、自动切换和容灾恢复，介绍计算资源、存储资源和网络资源的高可用实现方案。" 
                },
                {
                    name:"存储方案",
                    icon:require("../../assets/img/traning/icon5.png"),
                    des:"存储实现方案介绍，介绍云平台的存储架构，包括块存储、对象存储和文件存储，介绍分布式存储的实现原理及数据冗余机制。" 
                },
                {
                    name:"安全方案",
                    icon:require("../../assets/img/traning/icon6.png"),
                    des:"安全方案介绍，介绍云平台的安全架构，租户安全产品使用场景和实现说明。" 
                },
                {
                    name:"平台管理",
                    icon:require("../../assets/img/traning/icon7.png"),
                    des:"通过精心构建多样化故障场景，高度模拟真实运维环境中的故障排查流程，引导深入理解云平台的运行机制及资源下发流程、各组件的耦合关系。" 
                },
                {
                    name:"操作实践",
                    icon:require("../../assets/img/traning/icon8.png"),
                    des:"基于企业业务上云场景设置操作实践目标，帮助用户深入理解和使用云平台。" 
                },
            ],
        }
    },
    methods: {
        jumpToLogin() {
            this.$router.push('/trainCert/login');

        },
    },
    created() {
    
    },
    computed: {
    },
    mounted() {
    },
    watch: {
    }
};
</script>
<style lang="less" scoped>
.title-item{
    background-image: url("../../assets/img/traning/titlebg.png");
    height: 917px;
    background-size: cover;
    text-align: center;
    .title{
        font-family: AlibabaPuHuiTiM;
        font-size: 40px;
        color: #231A56;
        line-height: 52px;
        letter-spacing: 10px;
        text-shadow: 0px 2px 4px rgba(255,255,255,0.5);
        font-style: normal;
        padding: 72px 0 15px;
        font-weight: 700;
        min-width: 1477px;
    }
    .des{
        padding-bottom: 32px;
        font-family: AlibabaPuHuiTiR;
        font-size: 16px;
        color: rgba(0,0,0,0.9);
        line-height: 22px;
        text-shadow: 0px 1px 2px rgba(255,255,255,0.5);
        font-style: normal;
        min-width: 1477px;
    }
    .title-btn {
        padding-bottom: 20px;
        min-width: 1477px;
        .btn {
            font-weight: 500 !important;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;
            padding: 9px 44px !important;
        }
    }
    .detail-item{
        background-image: url("../../assets/img/traning/part1bg.png");
        height: 566px;
        width: 1477px;
        background-size: auto 100%;
        background-repeat-x: no-repeat;
        background-position: center;
        align-items: center;
        margin: auto;
        .item-line{
            padding: 150px 0;
            display: inline-flex;
            background-size: cover;
            .main-title {
                font-weight: 600;
                font-size: 42px;
                text-align: center;
                color: transparent;
                line-height: 59px;
                letter-spacing: 4px;
                text-shadow: 0px 2px 4px rgba(255,255,255,0.5);
                background: linear-gradient(180deg, #4632D9 0%, #9F44E0 100%);
                background-clip: text;
                -webkit-background-clip: text;
            }
            .item-des {
                padding-top: 10px;

                font-weight: 500;
                font-size: 18px;
                color: rgba(0,0,0,0.9);
                line-height: 34px;
                text-align: center;
                font-style: normal;
            }
        }

    }
}
.des-item {
    background-image: url("../../assets/img/traning/desbg.png");
    height: 791px;
    background-size: cover;
    text-align: center;
    .title {
        font-weight: 600;
        font-size: 40px;
        color: #FFFFFF;
        line-height: 56px;
        letter-spacing: 4px;
        text-align: center;
        font-style: normal;
        padding-top: 43px;
        min-width: 1477px;
    }
    .product-line {
        width: 1433px;
        margin: 62px auto;
        .product-item {
            width: 338px;
            height: 210px;
            background: rgba(255,255,255,0.9);
            border-radius: 18px;
            margin: 8px 10px;
            .product-icon {
                height: 40px;
                width: 40px;
                padding: 28px 271px 12px 31px;
            }
            .product-name {
                font-weight: 600;
                font-size: 14px;
                color: rgba(0,0,0,0.9);
                line-height: 20px;
                letter-spacing: 1px;
                text-align: left;
                font-style: normal;
                padding: 0 31px 8px;
            }
            .product-des {
                font-weight: 400;
                font-size: 12px;
                color: rgba(0,0,0,0.9);
                line-height: 17px;
                text-align: justify;
                font-style: normal;
                padding: 0 31px;
            }
        }
    }

}

.method-item {
    width: 1433px;
    margin: 56px auto;
    .title {
        font-weight: 600;
        font-size: 42px;
        color: rgba(0,0,0,0.9);
        line-height: 59px;
        letter-spacing: 4px;
        text-align: center;
        background-size: cover;
        margin-bottom: 38px;
        .colorful {
            text-shadow: 0px 2px 4px rgba(255,255,255,0.5);
            background: linear-gradient(180deg, #4632D9 0%, #9F44E0 100%);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
        }
    }
    .method-line {
        margin: 11px auto 169px;
        display: inline-flex;
        .method-card {
            width: 603px;
            height: 116px;
            background-size: cover;
            padding: 45px;
            .type {
                font-weight: bold;
                font-size: 26px;
                color: rgba(0,0,0,0.9);
                line-height: 39px;
                text-align: left;
                font-style: normal;
                margin: 3px 0 26px;
            }
            .des {
                width: 363px;
                font-weight: 400;
                font-size: 14px;
                color: rgba(0,0,0,0.7);
                line-height: 24px;
                text-shadow: 0px 2px 2px rgba(255,255,255,0.5);
                text-align: justify;
                font-style: normal;
            }
        }
        .bg1 {
            background-image: url("../../assets/img/traning/methodbg1.png");
        }
        .bg2 {
            background-image: url("../../assets/img/traning/methodbg2.png");
            margin-right: 47px;
        }
        

    }
    .groups-line {
        display: inline-flex;
        margin-bottom: 38px;
        .groups-card {
            width: 388px;
            height: 371px;
            background-size: cover;
            padding: 45px;
            .type {
                margin: 152px 0 49px;
                font-weight: 600;
                font-size: 26px;
                color: #000000;
                line-height: 37px;
                text-align: left;
                font-style: normal;
            }
            .des {
                font-weight: 400;
                font-size: 14px;
                color: rgba(0,0,0,0.9);
                line-height: 28px;
                text-align: justify;
                font-style: normal;
            }
        }
        .bg1 {
            background-image: url("../../assets/img/traning/groups-bg1.png");
        }
        .bg2 {
            background-image: url("../../assets/img/traning/groups-bg2.png");
        }
        .bg3 {
            background-image: url("../../assets/img/traning/groups-bg3.png");
        }
    }


}


</style>